// extracted by mini-css-extract-plugin
module.exports = {"outerDiv":"PropertiesGrid_outerDiv__HTNm0","grid":"PropertiesGrid_grid__PxDH2","loadMore":"PropertiesGrid_loadMore__7RlQT"};